import React, { useEffect, useState } from 'react'
import BookFreeClassBtn from '@components/common/book-free-class-btn'
import classNames from 'classnames'
import { Trans } from '@lingui/macro'

const CONTAINER_ID = 'codingal-product-blogs'

type Props = {
  urlQuery?: string
  isCodingForKids?: boolean
  isCoursePage?: boolean
  title?: string
  category?: string
}

const CodingalProductBlog = ({
  urlQuery,
  isCodingForKids,
  isCoursePage,
  title,
  category,
}: Props) => {
  const [isFetch, setIsFetch] = useState(false)

  const injectPage = async () => {
    const container = document.getElementById(CONTAINER_ID)
    if (!container) {
      console.error(`Container with id '${CONTAINER_ID}' not found`)
      return
    }

    // Fetch the courses HTML content without any query parameters
    const url = `https://www.codingal.com/blog/product-blogs/${
      category ? `?category=${category}` : ''
    }`

    try {
      const res = await fetch(url)
      if (!res.ok) {
        return
      }
      const coursesHtmlString = await res.text()
      setIsFetch(true)
      const parser = new DOMParser()
      const pageDom = parser.parseFromString(coursesHtmlString, 'text/html')
      const blogsDiv = pageDom.querySelector('#product-blogs')
      if (isCoursePage) {
        pageDom.querySelectorAll('.card_wrapper').forEach((card) => {
          card.classList.add('w-80')
        })
      }
      container.appendChild(blogsDiv)
    } catch (e) {
      console.error('Failed to fetch', e)
    }
  }

  useEffect(() => {
    injectPage()
  }, [])

  return (
    <div
      className={classNames(
        `flex flex-col ${
          isCoursePage
            ? 'my-10 lg:px-3 py-5'
            : 'pt-12 lg:pt-16 px-5 items-center'
        }`,
        {
          'mb-20': !isCodingForKids || !isCoursePage,
        }
      )}
    >
      <h2
        className={classNames('text-2xl font-600 pb-8 leading-tight', {
          'text-left': isCoursePage,
          'lg:text-4xl lg:pb-12': !isCoursePage,
        })}
      >
        {title ?? <Trans>Recent blog posts by Codingal</Trans>}
      </h2>
      <div id={CONTAINER_ID} />
      {isFetch && (
        <div
          className={classNames({
            'mx-auto w-full md:max-w-xs text-center mt-5': isCoursePage,
            'flex justify-center mt-10 lg:mx-0 pb-5 container w-full px-5': !isCoursePage,
          })}
        >
          <BookFreeClassBtn
            query={urlQuery}
            size={isCoursePage ? 'md' : 'xl'}
          />
        </div>
      )}
    </div>
  )
}

export default React.memo(CodingalProductBlog)
